
import React from 'react';
import { Star } from 'lucide-react';
import { cn } from '@/lib/utils';

interface RatingStarsProps {
  value?: number;
  rating?: number; // Added for backward compatibility 
  onChange?: (value: number) => void;
  max?: number;
  size?: 'sm' | 'md' | 'lg';
  readOnly?: boolean;
}

const RatingStars: React.FC<RatingStarsProps> = ({ 
  value = 0, 
  rating, // Added parameter
  onChange,
  max = 5,
  size = 'md',
  readOnly = false
}) => {
  // Use rating prop if provided (for backward compatibility), otherwise use value
  const displayRating = rating !== undefined ? rating : value;
  
  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-5 w-5',
    lg: 'h-6 w-6'
  };

  const handleClick = (rating: number) => {
    if (readOnly) return;
    if (onChange) onChange(rating);
  };

  return (
    <div className="flex items-center space-x-1">
      {Array.from({ length: max }).map((_, index) => {
        const starRating = index + 1;
        return (
          <Star
            key={index}
            className={cn(
              sizeClasses[size],
              'cursor-pointer transition-colors',
              starRating <= displayRating
                ? 'fill-yellow-400 text-yellow-400'
                : 'text-gray-300 fill-none',
              readOnly ? 'cursor-default' : 'hover:text-yellow-400'
            )}
            onClick={() => handleClick(starRating)}
            data-testid={`star-${starRating}`}
          />
        );
      })}
    </div>
  );
};

export default RatingStars;
